module.exports = __webpack_public_path__ + "static/media/ethax_staking.3e09f905.png";